import { Component, Input } from '@angular/core';
import { IInternalLinksResponse } from '../../../classes/interfaces';
import { CommunicationService } from '../../../services/communication.service';
import { SCREEN_SIZE, ListingCategory } from '../../../classes/enums';
import { HasSubscriptions } from '../../../components/has-subscriptions';
import { LandingPageConfigResponse } from '../../../resolvers/page-config-resolver';
import { InternalLinksService } from '../../../services/internalLinks.service';
import { TranslateService } from '@ngx-translate/core';
import {environment} from '../../../../environments/environment-wrapper';
@Component({
  selector: 'app-cms-links',
  templateUrl: './cms-links.component.html',
  styleUrls: ['./cms-links.component.scss']
})
export class CmsLinksComponent extends HasSubscriptions {

  @Input() links: IInternalLinksResponse | LandingPageConfigResponse;
  @Input() title: string;
  @Input() showNew: boolean = false;

  readonly endpoint = environment.cdnServerUrl;
  screenSize: SCREEN_SIZE;
  // Enums
  SCREEN_SIZE = SCREEN_SIZE;

  showMore: boolean = false;

  newestLinks = [
    'Page 1',
    'Page 2',
    'Page 3',
    'Page 4',
    'Page 5',
    'Page 6',
    'Page 7',
    'Page 8',
    'Page 9',
    'Page 10',
    'Page 11',
    'Page 12'
  ]

  constructor(
    private communicationService: CommunicationService,
    private internalLinksService: InternalLinksService,
    private translateService: TranslateService) {
    super();
    this.addSub(this.communicationService.screenSize.subscribe((s) => this.screenSize = s));
    this.addSub(this.communicationService.footerLinksChange.subscribe((place) => this.getFooterLinks(place, this.communicationService.listings.currentShownListingType.value)));
  }

  private getFooterLinks(place: { city: string, province: string }, listingCategory: ListingCategory) {
    this.addSub(
      this.internalLinksService.getLinks(place.province, place.city, listingCategory).subscribe((result) => { this.links = result; })
    );

    this.addSub(
      this.translateService.get('relevant-links.explore-links').subscribe((title: string) => {
        this.title = title;
      })
    )
  }

}
